import { classNames } from "primereact/utils";

import { useListToolbarContext } from "../list-toolbar.context";
import styles from "../list-toolbar.module.scss";
import type { ListToolbarActionsProps } from "../types-list-toolbar";

export function ListToolbarActions({ children, className, ...rest }: ListToolbarActionsProps) {
  const { classNames: parts, partTestId } = useListToolbarContext();

  return (
    <div
      className={classNames(styles.actions, parts.actions, className)}
      data-testid={partTestId("acoes")}
      {...rest}
    >
      {children}
    </div>
  );
}
ListToolbarActions.displayName = "ListToolbar.Actions";
